import { render, staticRenderFns } from "./EmployeeFormattedName.vue?vue&type=template&id=6a936808&"
import script from "./EmployeeFormattedName.vue?vue&type=script&lang=js&"
export * from "./EmployeeFormattedName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports